/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'description': {
    width: 640,
    height: 640,
    viewBox: '-72 0 480 480',
    data: '<path pid="0" d="M312 0H24C10.398 0 0 10.398 0 24v432c0 13.602 10.398 24 24 24h219.2l92.8-92.8V24c0-13.602-10.398-24-24-24zm8 380.8l-72 72V400c0-4.8 3.2-8 8-8h40v-16h-40c-13.602 0-24 10.398-24 24v64H24c-4.8 0-8-3.2-8-8V24c0-4.8 3.2-8 8-8h288c4.8 0 8 3.2 8 8zm0 0"/><path pid="1" d="M120 48h96v16h-96zm0 0M64 264h208v16H64zm0 0M64 304h208v16H64zm0 0M64 344h208v16H64zm0 0M64 384h136v16H64zm0 0M240 212.8v-97.6l-72-36-72 36v97.6l72 36zm-72-62.402l-20-12 48-27.199 20 9.602zm10.398-48l-45.597 26.403-12.801-8 48-24zm-66.398 32L160 164v46.398h16V164l48-29.602V203.2l-56 28-56-28zm0 0"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/description.js